export default "__VITE_ASSET__oRse4Ua2__"